"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarTimeoutSeconds = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var Icon_1 = __importDefault(require("../icon/Icon"));
var Button_1 = __importDefault(require("../button/Button"));
var WebUtils_1 = __importDefault(require("epc-web-utils/dist/WebUtils"));
var BottomSheet_1 = require("../bottom-sheet/BottomSheet");
var ChildrenUtils_1 = require("../../common/ChildrenUtils");
var buttonType = (react_1.default.createElement(Button_1.default, null)).type;
var useBottomOffset = function () {
    var bottomSheetEventAttachState = react_1.useState(true)[0];
    var _a = react_1.useState({
        visible: BottomSheet_1.isVisible(),
        offset: BottomSheet_1.getVisibleOffset()
    }), bottomSheetDomState = _a[0], setBottomSheetDomState = _a[1];
    react_1.useEffect(function () {
        WebUtils_1.default.attachEvent('Ferris.Components.BottomSheet.Visibility', function (e) {
            setBottomSheetDomState(__assign({}, e.data));
        });
    }, [bottomSheetEventAttachState]);
    if (bottomSheetDomState && bottomSheetDomState.visible) {
        return bottomSheetDomState.offset;
    }
    return undefined;
};
var mergeStyle = function (style, bottom) {
    var mergedStyle = {
        style: style
    };
    if (bottom) {
        if (!mergedStyle.style) {
            mergedStyle.style = {};
        }
        mergedStyle = {
            style: __assign(__assign({}, mergedStyle.style), { bottom: bottom })
        };
    }
    return mergedStyle;
};
var SnackbarTimeoutSeconds;
(function (SnackbarTimeoutSeconds) {
    SnackbarTimeoutSeconds[SnackbarTimeoutSeconds["FOUR"] = 4000] = "FOUR";
    SnackbarTimeoutSeconds[SnackbarTimeoutSeconds["FIVE"] = 5000] = "FIVE";
    SnackbarTimeoutSeconds[SnackbarTimeoutSeconds["SIX"] = 6000] = "SIX";
    SnackbarTimeoutSeconds[SnackbarTimeoutSeconds["SEVEN"] = 7000] = "SEVEN";
    SnackbarTimeoutSeconds[SnackbarTimeoutSeconds["EIGHT"] = 8000] = "EIGHT";
    SnackbarTimeoutSeconds[SnackbarTimeoutSeconds["NINE"] = 9000] = "NINE";
    SnackbarTimeoutSeconds[SnackbarTimeoutSeconds["TEN"] = 10000] = "TEN";
})(SnackbarTimeoutSeconds = exports.SnackbarTimeoutSeconds || (exports.SnackbarTimeoutSeconds = {}));
var Snackbar = function (props) {
    var children = props.children, classes = props.classes, icon = props.icon, longAction = props.longAction, visible = props.visible, timeout = props.timeout, onSnackbarClose = props.onSnackbarClose, otherProps = __rest(props, ["children", "classes", "icon", "longAction", "visible", "timeout", "onSnackbarClose"]);
    var _a = react_1.useState(visible), visibleState = _a[0], setVisibleState = _a[1];
    react_1.useEffect(function () {
        setVisibleState(visible);
        var timer = setTimeout(function () {
            setVisibleState(false);
            onSnackbarClose && onSnackbarClose(false);
        }, timeout);
        return function () { return clearTimeout(timer); };
    }, [visible, timeout, setVisibleState, onSnackbarClose]);
    var bottomOffset = useBottomOffset();
    var style = otherProps.style, otherPropsExcludingStyle = __rest(otherProps, ["style"]);
    var mergedStyle = mergeStyle(style, bottomOffset);
    return (react_1.default.createElement("div", __assign({ className: getClassNames(visibleState, classes) }, otherPropsExcludingStyle, mergedStyle),
        icon && (react_1.default.createElement("div", { className: "fds-snackbar-icon fds-cell all-cell-1-3 all-cell-shrink" }, icon)),
        react_1.default.createElement("div", { className: "fds-snackbar-content fds-cell all-cell-1-3 all-cell-fill" }, getContentChildren(children)),
        getButtonChildren(children, longAction)));
};
var getContentChildren = function (children) {
    return ChildrenUtils_1.filterChildrenOut(children, buttonType);
};
var isIconButton = function (buttons) {
    return buttons && buttons.every(function (button) {
        var children = button && button.props && button.props.children;
        if (!children) {
            return false;
        }
        return Array.isArray(children) ?
            children.every(function (child) { return child.type === Icon_1.default; }) :
            children.type === Icon_1.default; //eslint-disable-line @typescript-eslint/no-explicit-any
    });
};
var getButtonClassNames = function (buttons, long) {
    var iconButton = isIconButton(buttons);
    return classnames_1.default('fds-snackbar-action', 'fds-cell', 'all-cell-1-3', 'all-cell-shrink', {
        'fds-snackbar-action-icon': iconButton,
        'fds-snackbar-action-long': !iconButton && long
    });
};
var getButtonChildren = function (children, longAction) {
    var buttonChildren = ChildrenUtils_1.filterChildrenIn(children, buttonType);
    if (buttonChildren.length === 0) {
        return null;
    }
    return (react_1.default.createElement("div", { className: getButtonClassNames(buttonChildren, longAction) }, buttonChildren));
};
var getClassNames = function (visible, classes) {
    return classnames_1.default('fds-snackbar', 'fds-grid', {
        'is-visible': visible
    }, classes);
};
Snackbar.defaultProps = {
    timeout: SnackbarTimeoutSeconds.FOUR
};
exports.default = Snackbar;
